// import logo from './logo.svg';
// import './App.css';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Login from './pages/Login';
import Users from './pages/users';
import EditUser from './pages/EditUser';
import EditPort from './pages/EditPort';
// import AddCommission from './pages/commission_add/view/commission';

import EditProduct from './pages/edit_product/view/edit_product';
import Blogs from './pages/blogs';
import Brands from './pages/Brands';
import EditBrand from './pages/EditBrand';
import Products from './pages/Products';
import Promotions from './pages/Promotions';
import Categories from './pages/categories/view/Categories';
import EditBlog from './pages/EditBlog';
import Tags from './pages/Tags';
// import Dashboard2 from './pages/dashboard2';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/protectedRoute';
import { routeName } from './routes/paths';

// function ProtectRoute(prop) {
//   return <Route {...prop} />;
// }

function App() {
  return (
    <AuthProvider>
      <SnackbarProvider maxSnack={4}>
        <BrowserRouter>
          <Routes>
            <Route exact path={routeName.LOGIN} element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path={routeName.BRANDS} element={<Brands />} />
              <Route path={routeName.EDITBRANDS} element={<EditBrand />} />
              <Route path={routeName.CATEGORIES} element={<Categories />} />
              <Route path={routeName.USERS} element={<Users />} />
              <Route path={routeName.BLOGS} element={<Blogs />} />
              <Route path={routeName.EDITUSER} element={<EditUser />} />
              <Route path={routeName.EDITPORT} element={<EditPort />} />
              {/* <Route path={routeName.ADDCOMMISSION} element={<AddCommission />} /> */}
              <Route path={routeName.PROMOTIONS} element={<Promotions />} />
              {/* <Route path={routeName.EDITPR} element={<CommissionDetail />} /> */}
              <Route path={routeName.PRODUCTS} element={<Products />} />
              <Route path={routeName.EDITPRODUCT} element={<EditProduct />} />
              <Route path={routeName.EDITBLOG} element={<EditBlog />} />
              <Route path={routeName.TAGS} element={<Tags />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </SnackbarProvider>
    </AuthProvider>
  );
}

export default App;
